export default __webpack_public_path__ + "static/media/hill.9806ec71.png";